<template>
  <div class="status-modal">
    <div class="status-modal__header flex items-center justify-between">
      <div :class="['status-modal__title', titleClass]">
        {{ titleText }}
      </div>
      <button type="button" class="cursor-pointer" @click="$emit('close')">
        <Icon icon-name="CloseIcon" />
      </button>
    </div>

    <div class="status-modal__body mt-4 space-y-3">
      <p class="status-modal__question text-base font-semibold text-slate-700">
        {{ questionText }}
      </p>
      <p class="status-modal__description text-sm text-slate-500">
        {{ descriptionText }}
      </p>
    </div>

    <div class="status-modal__footer mt-6 flex items-center gap-3">
      <button
        type="button"
        :class="['status-modal__confirm', confirmButtonClass]"
        @click="$emit('confirm')"
      >
        Confirm
      </button>
      <button
        type="button"
        class="status-modal__cancel flex items-center justify-center rounded-lg border border-slate-600 px-4 py-2 text-sm font-semibold text-slate-600 transition focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-none"
        @click="$emit('cancel')"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import Icon from "../core/Icon.vue";

export default {
  name: "StatusConfirmationModal",
  components: {
    Icon
  },
  props: {
    variant: {
      type: String,
      default: "activate",
      validator(value) {
        return ["activate", "deactivate"].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    isActivate() {
      return this.variant === "activate";
    },
    titleText() {
      return this.isActivate
        ? "Set Tenant Subscription Active"
        : "Set Tenant Subscription Inactive";
    },
    questionText() {
      return this.isActivate
        ? "Are you sure you want to set this subscription active?"
        : "Are you sure you want to set this subscription inactive?";
    },
    descriptionText() {
      return this.isActivate
        ? "This will reactivate the tenant's subscription and restore their access to the system."
        : "This will disable the tenant's account and related activities until reactivated.";
    },
    titleClass() {
      return this.isActivate ? "text-blue-600" : "text-red-600";
    },
    confirmButtonClass() {
      return this.isActivate
        ? "flex w-full items-center justify-center rounded-lg bg-blue-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-600 focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-none"
        : "flex w-full items-center justify-center rounded-lg bg-red-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-600 focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-none";
    }
  }
};
</script>
